
//REDUCER
const clubReducer = (state = "", action) => {
    switch (action.type) {
      case 'set':
        state = action.payload;
        return state;
      case 'unset':
        state= 0;
        return state ;
     default:
       return state;
  
    }
};

export default clubReducer;